import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'María G.',
  location: 'Córdoba',
  text: 'Con la guía pude fabricar mis primeros productos el mismo fin de semana. Ya estoy vendiendo a vecinos y comercios.',
  img: 'https://randomuser.me/api/portraits/women/44.jpg'
}, {
  name: 'Lucas F.',
  location: 'Buenos Aires',
  text: 'Lo que más me gustó fue que explica exactamente qué comprar y dónde conseguirlo.',
  img: 'https://randomuser.me/api/portraits/men/32.jpg'
}, {
  name: 'Carla M.',
  location: 'Rosario',
  text: 'Arranqué para ahorrar dinero en mi casa y terminé creando un ingreso extra.',
  img: 'https://randomuser.me/api/portraits/women/68.jpg'
}, {
  name: 'Roberto A.',
  location: 'Mendoza',
  text: 'La capacitación de piscinas sola ya vale el precio de todo el pack.',
  img: 'https://randomuser.me/api/portraits/men/22.jpg'
}, {
  name: 'Valeria S.',
  location: 'Neuquén',
  text: 'Todo está explicado de manera sencilla. Ideal para personas sin experiencia.',
  img: 'https://randomuser.me/api/portraits/women/55.jpg'
}];
export function Testimonials() {
  return <section className="py-8 md:py-16 px-4 bg-dark-900 border-t border-dark-800" data-id="element-202">
      <div className="max-w-6xl mx-auto" data-id="element-203">
        <div className="text-center mb-8 md:mb-12" data-id="element-204">
          <h2 className="text-xl md:text-5xl font-black text-white mb-3 md:mb-4 uppercase leading-snug" data-id="element-205">
            💬 LO QUE DICEN NUESTROS{' '}
            <span className="text-brand-400" data-id="element-206">ALUMNOS</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 justify-center" data-id="element-207">
          {testimonials.map((t, i) => <div key={i} className="bg-dark-800 p-5 md:p-6 rounded-2xl shadow-md border border-dark-700 flex flex-col h-full" data-id="element-208">
              <div className="flex items-center gap-1 text-yellow-400 mb-3 md:mb-4" data-id="element-209">
                {[...Array(5)].map((_, j) => <Star key={j} size={14} className="md:w-4 md:h-4" fill="currentColor" data-id="element-210" />)}
              </div>
              <p className="text-sm md:text-base text-gray-300 font-medium italic mb-4 md:mb-6 flex-grow" data-id="element-211">
                "{t.text}"
              </p>
              <div className="flex items-center gap-3 mt-auto pt-3 md:pt-4 border-t border-dark-700" data-id="element-212">
                <img src={t.img} alt={t.name} className="w-10 h-10 md:w-12 md:h-12 rounded-full object-cover" data-id="element-213" />
                <div data-id="element-214">
                  <p className="font-bold text-xs md:text-sm text-gray-200" data-id="element-215">
                    {t.name}
                  </p>
                  <p className="text-[10px] md:text-xs text-gray-500" data-id="element-216">
                    {t.location}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}